import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./calendar.scss";
import { useEffect, useRef, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import moment from "moment-with-locales-es6";
import * as $ from "jquery";
import { IonicLoaderComponent } from "ionic-loader";
import { useLocalStorage } from "../../hooks";
import lnbp_logo from "./../../icon/icon.png";
import calendar_hash from "./../../icon/7_CalendarioHashtag.png";
import { GoogleMap } from "@capacitor/google-maps";

const CalendarDetail: React.FC = () => {
  moment.locale("es");

  const [showProgessBar, setShowProgessBar] = useState(false);
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  var moment_today = moment();

  var moment_current = moment_today.clone();
  const urlParams = new URLSearchParams(window.location.search);
  const [needRefresh, setNeedRefresh] = useLocalStorage("needRefresh", true);

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    // let coffee = new coffeeTools();
    // console.log(coffee.test(123));
    setNeedRefresh(true);
    // createMap();
    // createMap();
  }, []);

  var controller = (() => {
    function getBanner(id_entry, callback) {
      var ajax_data = {
        id: id_entry
      };
      fetch(process.env.REACT_APP_BASE_URL + "/cms/entries/single", {
        method: "POST",
        body: JSON.stringify(ajax_data),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then((data) => {
          callback(data);
        });
    }

    function getEvent(callback) {
      fetch(process.env.REACT_APP_BASE_URL + "/sports/games/single", {
        method: "POST",
        body: JSON.stringify({
          id: urlParams.get("cs_load_game")
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then((data) => {
          callback(data);
        });
    }
    return {
      getBanner: (id_entry, callback) => getBanner(id_entry, callback),
      getEvent: (callback) => getEvent(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      banner_image: "js__banner_image",
      banner_container: "js__banner_image_container",
      event_date: "js__event_date",
      event_game_data_date: "js__event_game_data_date",
      event_game_data_place: "js__event_game_data_place",
      event_teams_team_1_logo: "js__event_teams_team_1_logo",
      event_teams_team_1_name: "js__event_teams_team_1_name",
      event_teams_team_2_logo: "js__event_teams_team_2_logo",
      event_teams_team_2_name: "js__event_teams_team_2_name",
      event_game_controles_live: "js__event_game_controles_live",
      event_game_controles_contact: "js__event_game_controles_contact",
      event_game_controles_web: "js__event_game_controles_web"
    };

    /* Banner */
    function displayTopBanner(data) {
      let image = document.getElementById(
        dom_obj.banner_image
      ) as HTMLImageElement;
      image.src = process.env.REACT_APP_BASE_URL + data.item.full_url_image;

      if (
        data.item.full_url_image != null &&
        !data.item.full_url_image.includes("no-image.jpg")
      ) {
      }
    }

    function displayEvent(data) {
      console.log("this is game data", data);
      let game_data = data.item;

      let event_date = game_data.event.date_start;

      let participant_1_logo = game_data.team_1.full_url_logo;
      let participant_1_name = game_data.team_1.name;

      let participant_2_logo = game_data.team_2.full_url_logo;
      let participant_2_name = game_data.team_2.name;

      let game_date =
        "Hora: <b>" +
        game_data.event.time_start.slice(0, 5) +
        " a " +
        game_data.event.time_end.slice(0, 5) +
        "</b>";
      let game_place = "lugar: <b>" + game_data.event.address.name + "</b>";

      let url_live_stream = game_data.url_live;
      let url_contact = game_data.event.contact.phone;
      let url_website = game_data.event.website;

      let event_latitude = game_data.event.address.latitude;
      let event_longitude = game_data.event.address.longitude;

      (
        document.getElementById(dom_obj.event_date) as HTMLHeadingElement
      ).innerHTML = event_date;
      (
        document.getElementById(
          dom_obj.event_teams_team_1_logo
        ) as HTMLImageElement
      ).src = base_url + participant_1_logo;
      (
        document.getElementById(
          dom_obj.event_teams_team_1_name
        ) as HTMLImageElement
      ).innerHTML = participant_1_name;
      (
        document.getElementById(
          dom_obj.event_teams_team_2_logo
        ) as HTMLImageElement
      ).src = base_url + participant_2_logo;
      (
        document.getElementById(
          dom_obj.event_teams_team_2_name
        ) as HTMLImageElement
      ).innerHTML = participant_2_name;
      (
        document.getElementById(dom_obj.event_game_data_date) as HTMLSpanElement
      ).innerHTML = game_date;
      (
        document.getElementById(
          dom_obj.event_game_data_place
        ) as HTMLSpanElement
      ).innerHTML = game_place;

      // bind buttons
      // live stream button
      let button_live_stream = document.getElementById(
        dom_obj.event_game_controles_live
      ) as HTMLButtonElement;
      if (url_live_stream !== undefined && url_live_stream !== "") {
        button_live_stream.addEventListener(
          "click",
          (e) => {
            window.open(url_live_stream, "_blank");
          },
          false
        );
      } else {
        button_live_stream.setAttribute("disabled", "true");
        button_live_stream.style.backgroundColor = "grey";
      }

      // contact button
      let button_contact = document.getElementById(
        dom_obj.event_game_controles_contact
      ) as HTMLButtonElement;
      if (url_contact !== undefined && url_contact !== "") {
        button_contact.addEventListener(
          "click",
          (e) => {
            window.open(url_live_stream, "_blank");
          },
          false
        );
      } else {
        button_contact.setAttribute("disabled", "true");
        button_contact.style.backgroundColor = "grey";
      }

      button_contact.addEventListener(
        "click",
        (e) => {
          window.open(url_live_stream, "_blank");
        },
        false
      );

      // website button
      let button_website = document.getElementById(
        dom_obj.event_game_controles_web
      ) as HTMLButtonElement;
      if (url_website !== undefined && url_website !== "") {
        button_website.addEventListener(
          "click",
          (e) => {
            window.open(url_contact, "_blank");
          },
          false
        );
      } else {
        button_website.setAttribute("disabled", "true");
        button_website.style.backgroundColor = "grey";
      }

      // create map
      let map: google.maps.Map;
      const center: google.maps.LatLngLiteral = {
        lat: parseFloat(event_latitude),
        lng: parseFloat(event_longitude)
      };

      map = new google.maps.Map(
        document.getElementById("js__event_map") as HTMLElement,
        {
          center,
          zoom: 13
        }
      );

      // (async () => {
      //   const mapRef = document.getElementById("js__event_map");

      //   const newMap = await GoogleMap.create({
      //     id: "my-map", // Unique identifier for this map instance
      //     element: mapRef, // reference to the capacitor-google-map element
      //     apiKey: "AIzaSyCJAsF8wG2Htu0D99PtIgAiA3fVW2ORQF8", // Your Google Maps API Key
      //     config: {
      //       center: {
      //         // The initial position to be rendered by the map
      //         lat: parseFloat(event_latitude),
      //         lng: parseFloat(event_longitude)
      //       },
      //       zoom: 13 // The initial zoom level to be rendered by the map
      //     }
      //   });
      // })();
    }

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      displayTopBanner: (id_entry) => displayTopBanner(id_entry),
      displayEvent: (data) => displayEvent(data),
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};

    return {
      init: function () {
        // console.log("Menu started");
        setupEventListeners();
        // page_controller.getBanner(29, page_view.displayTopBanner);
        coffee_tools.showRotateBanner();

        page_controller.getEvent(page_view.displayEvent);
        page_view.createSectionTitles(
          "Calendario",
          "js__calendar_detail_title"
        );

        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <IonImg
            src={lnbp_logo}
            style={{ height: "4rem" }}
          ></IonImg>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {/* <div id="js__page_template_content"></div> */}
        <div id='js__calendar_detail_title'></div>
        <div
          id='js__event_container'
          style={{
            margin: "1rem",
            boxShadow: "rgba(53, 53, 53, 0.2) 7px 7px 10px",
            borderRadius: "1rem"
          }}
        >
          <div
            id='js__event_lnbp_logo'
            style={{ margin: "0", padding: "0" }}
          >
            <IonImg
              src={calendar_hash}
              style={{
                height: "4rem",
                backgroundColor: "black",
                borderRadius: "1rem 1rem 0 0"
              }}
            ></IonImg>
          </div>
          <div
            className='ion-text-center'
            style={{ margin: "0", padding: "0" }}
          >
            <div style={{ textAlign: "left" }}>
              <h2
                id='js__event_date'
                style={{
                  marginLeft: "1rem",
                  fontWeight: "bold",
                  marginBottom: "0"
                }}
              >
                Junio 22 2022
              </h2>
              <hr
                style={{
                  marginLeft: "1rem",
                  width: "5rem",
                  height: "0.2rem",
                  color: "red",
                  backgroundColor: "red",
                  display: "inline-block",
                  textAlign: "left"
                }}
              />
            </div>
          </div>
          <div
            id='js__event_teams'
            style={{ margin: "0", padding: "0", backgroundColor: "#FAFAFA" }}
          >
            <table
              className='ion-text-center'
              style={{ width: "100%", padding: "1rem" }}
            >
              <tbody>
                <tr style={{ padding: "1rem", display: "inline-block" }}>
                  <td
                    className='ion-text-center'
                    style={{ width: "40%" }}
                  >
                    <img
                      id='js__event_teams_team_1_logo'
                      style={{ width: "5rem" }}
                      src={lnbp_logo}
                      alt=''
                    />
                    <span
                      style={{
                        width: "100%",
                        display: "inline-block",
                        color: "black"
                      }}
                      id='js__event_teams_team_1_name'
                    >
                      Equipo
                    </span>
                  </td>
                  <td style={{ width: "20%", color: "black" }}>VS</td>
                  <td
                    className='ion-text-center'
                    style={{ width: "40%" }}
                  >
                    <img
                      id='js__event_teams_team_2_logo'
                      style={{ width: "5rem" }}
                      src={lnbp_logo}
                      alt=''
                    />
                    <span
                      style={{
                        width: "100%",
                        display: "inline-block",
                        color: "black"
                      }}
                      id='js__event_teams_team_2_name'
                    >
                      Equipo
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            id='js__event_game_data'
            style={{ padding: "1rem" }}
          >
            <div>
              <span id='js__event_game_data_date'>
                Hora <b>8:00 om a 10:00om</b>
              </span>
            </div>
            <br />
            <div>
              <span id='js__event_game_data_place'>
                Lugar <b>8:00 om a 10:00om</b>
              </span>
            </div>
            <br />
            <div
              id='js__event_map'
              style={{ height: "12rem", borderRadius: "1rem" }}
            ></div>
          </div>
          <div id='js__event_game_controles'>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr className='ion-text-center'>
                  <td style={{ width: "33%", padding: "0.2rem" }}>
                    <button
                      id='js__event_game_controles_live'
                      style={{
                        width: "100%",
                        backgroundColor: "black",
                        padding: "1rem",
                        color: "white",
                        borderRadius: "1rem"
                      }}
                    >
                      Ver en Vivo
                    </button>
                  </td>
                  <td style={{ width: "33%", padding: "0.2rem" }}>
                    <button
                      id='js__event_game_controles_contact'
                      style={{
                        width: "100%",
                        backgroundColor: "black",
                        padding: "1rem",
                        color: "white",
                        borderRadius: "1rem"
                      }}
                    >
                      Contacto
                    </button>
                  </td>
                  <td style={{ width: "33%", padding: "0.2rem" }}>
                    <button
                      id='js__event_game_controles_web'
                      style={{
                        width: "100%",
                        backgroundColor: "black",
                        padding: "1rem",
                        color: "white",
                        borderRadius: "1rem"
                      }}
                    >
                      Web
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <a id='js__banner_image_anchor'>
          <img
            style={{ padding: "1rem" }}
            id='js__banner_image'
            alt=''
          />
        </a>
      </IonContent>
    </IonPage>
  );
};

export default CalendarDetail;
